import React, { useState } from 'react'
import { MdPassword } from 'react-icons/md'
import { useSelector } from 'react-redux'
import Modal from '../../components/Display/Modal'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { RootState } from '../../redux/store'
import { AuthService } from '../../services/AuthService'
import ChangeCurrentUserPassword from './ChangeCurrentUserPassword'

let authService = new AuthService()

const NotMasterConfiguration = () => {
  const { addAlert } = useSnackBars()

  const [cardOptions] = useState([
    {
      icon: MdPassword,
      title: 'Cambiar contraseña',
      subTitle: 'Modifica tu contraseña.',
    },
  ])

  const [
    showModalChangePassword,
    setShowModalChangePassword,
  ] = useState<boolean>(false)

  const onClickCard = (idx) => {
    if (idx === 0) {
      setShowModalChangePassword(true)
    }
  }

  return (
    <div className="grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6 px-1">
      {cardOptions.map((card, idx) => (
        <div className="2xl:w-96 w-96 h-36 shadow-lg rounded-lg p-4 mb-5 mr-5 text-xl relative dark:bg-black m-auto cursor-pointer" onClick={() => onClickCard(idx)}>
          {/* <h1>card...</h1> */}
          <div className="flex">
            <div
              style={{ backgroundColor: '#006AEA33', height: 30, width: 30 }}
              className="flex justify-center items-center"
            >
              <card.icon color="#0033A0" />
            </div>

            <div className="ml-3">
              <label className="text-base font-medium">{card.title}</label>
            </div>
          </div>

          <div
              style={{ width: '100%', height: 2, backgroundColor: '#CFCDCD', marginTop: 10 }}
            ></div>

          <div className="mt-2">
            <label className="text-sm" style={{ color: '#5A5B66' }}>
              {card.subTitle}
            </label>
          </div>

          {/* <div
            style={{
              position: 'absolute',
              bottom: 0,
              width: '100%',
              padding: 'inherit',
              left: 0,
              right: 0,
            }}
          >
            <div
              style={{ width: '100%', height: 2, backgroundColor: '#CFCDCD' }}
            ></div>

            <div className="flex justify-end mt-2">
              <label
                className="text-base text-primary cursor-pointer"
                onClick={() => onClickCard(idx)}
              >
                Editar
              </label>
            </div>
          </div> */}
        </div>
      ))}

      <Modal
        display={showModalChangePassword}
        onClose={() => setShowModalChangePassword(false)}
        xlClasses="xl:w-2/6"
      >
        <ChangeCurrentUserPassword
          onSubmit={async (values) => {
            addAlert({
              message: 'Cambiando contraseña',
              status: 'loading',
            })
            try {
              await authService.changePassword(
                values?.currentPassword,
                values?.newPassword
              )
              addAlert({
                message: 'Contraseña cambiada satisfactoriamente',
                status: 'success',
              })
              setShowModalChangePassword(false)
            } catch (err: any) {
              if (err.code === 'NotAuthorizedException') {
                addAlert({
                  message: 'Contraseña incorrecta',
                  status: 'error',
                })
                return
              }
              addAlert({
                message: 'Error al cambiar contraseña',
                status: 'error',
              })
            }
          }}
          onClose={() => setShowModalChangePassword(false)}
        />
      </Modal>
    </div>
  )
}

export default NotMasterConfiguration
